import * as React from 'react';

import NotificationCenter from 'bundles/notification-center/components/NotificationCenter';
import NotificationIcon from 'bundles/notification-center/components/NotificationIcon';

const NotificationsLegacyGridItem = () => {
  const [renderIconOnly, setRenderIconOnly] = React.useState(true);

  React.useEffect(() => {
    setRenderIconOnly(false);
  }, []);

  return renderIconOnly ? (
    <NotificationIcon unreadCount={0} active={false} onClick={() => {}} />
  ) : (
    <NotificationCenter />
  );
};

export default NotificationsLegacyGridItem;
